import React, { PureComponent } from 'react';

import CalendarBase from './calendar-base/CalendarBase';
import * as CalendarState from '../../state/reducer/calendar/calendar';
import { getStore } from '../../state/store';
import loadReactions from '../../v5/messaging/state/loadReactions';
import Console from '../../lib/debug';

export default class AthleteCalendarView extends PureComponent {
    constructor(props) {
        super(props);
        this.loadCalendarData(props);
    }

    componentWillUpdate(nextProps) {
        this.loadCalendarData(nextProps);
    }

    getParamsFromProps(props) {
        const athleteId = parseInt(props.match.params.athleteId, 10);
        const year = parseInt(props.match.params.year, 10);
        const month = parseInt(props.match.params.month, 10);
        return {
            athleteId,
            year,
            month
        };
    }

    loadCalendarData(props) {
        const params = this.getParamsFromProps(props);
        CalendarState.loadAthleteCalendar(
            params.athleteId,
            params.year,
            params.month
        );
        getStore().dispatch(loadReactions());
    }

    render() {
        Console.render('AthleteCalendarView');
        return (
            <CalendarBase
                messagingCallback={() => {
                    const params = this.getParamsFromProps(this.props);
                    CalendarState.loadSummaries(
                        params.athleteId,
                        params.year,
                        params.month
                    );
                }}
            />
        );
    }
}
